import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Label } from "@radix-ui/react-label";
import { ChevronDown, MapPin } from "lucide-react";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import type { DownloadOptions } from "@/constants";
import { SortOptions } from "@/constants";
import { setSort } from "@/store/price transparency/price-transparency-slice";
import { capitalize } from "lodash";
import useCostEstFilter from "@/hooks/use-cost-est-filter";

const CostEstimatorActions = ({
  // onDownload,
  onSort,
  onMapView,
  // showDownloadLoader = false,
}: {
  onDownload: (option: DownloadOptions) => void;
  onSort: (option: SortOptions) => void;
  onMapView: (index: number | null) => void;
  showDownloadLoader?: boolean;
}) => {
  // const [downloadOpen, setDownloadOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const dispatch = useDispatch();
  const costEstFilterParams = useCostEstFilter();

  return (
    <section className="m-2 flex flex-row items-center justify-between">
      <div className="flex flex-row items-center gap-2">
        <Button
          type="button"
          className="items-center justify-center rounded-md bg-primary hover:bg-primary-selected"
          onClick={() => onMapView(null)}
        >
          <Label className="text-white">Map View</Label>
          <MapPin className="text-white" />
        </Button>

        {/*Commented out because the CSP prevents the download.
        The API will handle PDF preparation.
        When ready, front-end logic will be replaced by an API call.*/}

        {/*<DropdownMenu open={downloadOpen} onOpenChange={setDownloadOpen}>*/}
        {/*  <DropdownMenuTrigger asChild>*/}
        {/*    <Button*/}
        {/*      type="button"*/}
        {/*      className="items-center justify-center rounded-md bg-primary hover:bg-primary-selected"*/}
        {/*      disabled={showDownloadLoader}*/}
        {/*    >*/}
        {/*      {showDownloadLoader ? (*/}
        {/*        <Label className="text-white">Downloading...</Label>*/}
        {/*      ) : (*/}
        {/*        <>*/}
        {/*          <Label className="text-white">Download</Label>*/}
        {/*          <Download className="text-white" />*/}
        {/*        </>*/}
        {/*      )}*/}
        {/*    </Button>*/}
        {/*  </DropdownMenuTrigger>*/}
        {/*  <DropdownMenuContent>*/}
        {/*    <DropdownMenuItem*/}
        {/*      onClick={() => {*/}
        {/*        //dispatch(setLimit(DownloadOptions.FIRST_10));*/}
        {/*        onDownload(DownloadOptions.FIRST_10);*/}
        {/*        setDownloadOpen(false);*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Label>First 10 Results</Label>*/}
        {/*    </DropdownMenuItem>*/}
        {/*    <DropdownMenuItem*/}
        {/*      onClick={() => {*/}
        {/*        //dispatch(setLimit(DownloadOptions.FIRST_50));*/}
        {/*        onDownload(DownloadOptions.FIRST_50);*/}
        {/*        setDownloadOpen(false);*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Label>First 50 Results</Label>*/}
        {/*    </DropdownMenuItem>*/}
        {/*    <DropdownMenuItem*/}
        {/*      onClick={() => {*/}
        {/*        //dispatch(setLimit(DownloadOptions.FIRST_100));*/}
        {/*        onDownload(DownloadOptions.FIRST_100);*/}
        {/*        setDownloadOpen(false);*/}
        {/*      }}*/}
        {/*    >*/}
        {/*      <Label>First 100 Results</Label>*/}
        {/*    </DropdownMenuItem>*/}
        {/*  </DropdownMenuContent>*/}
        {/*</DropdownMenu>*/}
      </div>

      <DropdownMenu open={sortOpen} onOpenChange={setSortOpen}>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            className="w-40 items-center justify-center rounded-md"
          >
            <Label>
              Sort by: {capitalize(costEstFilterParams.sort.toLowerCase())}
            </Label>
            <ChevronDown className="text-muted-foreground" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem
            onClick={() => {
              dispatch(setSort(SortOptions.COST));
              onSort(SortOptions.COST);
              setSortOpen(false);
            }}
          >
            <Label>Cost (Low to High)</Label>
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              dispatch(setSort(SortOptions.DISTANCE));
              onSort(SortOptions.DISTANCE);
              setSortOpen(false);
            }}
          >
            <Label>Distance (Closest)</Label>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </section>
  );
};

export default CostEstimatorActions;
